// extracted by mini-css-extract-plugin
module.exports = {"value":"JournalRowIndicator_value__3UK1Y","title":"JournalRowIndicator_title__1Ep2V","container":"JournalRowIndicator_container__3LdVl"};